import React from 'react'
import { LoginSelfServiceCipAndFap } from 'redesign/components/organisms/SelfService/LoginSelfServiceCipAndFap'
import { useLoginSelfService } from 'redesign/store'
import { LoginSelfServiceCPF } from 'redesign/components/organisms/SelfService/LoginSelfServiceCPF'

export function LoginSelfService() {
    const { page } = useLoginSelfService()

    if (page === 'cpf') {
        return <LoginSelfServiceCPF />
    }

    return <LoginSelfServiceCipAndFap />
}
